"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CarouselImagesLogin = void 0;

var _styles = require("./styles");

var _ScreenHeader = require("../../atoms/ScreenHeader");

var _variables = require("../../../global-files/variables");

var _react = require("react");

var _jsxRuntime = require("react/jsx-runtime");

var CarouselImagesLogin = function CarouselImagesLogin(_ref) {
  var _ref$panelImg = _ref.panelImg,
      panelImg = _ref$panelImg === void 0 ? [] : _ref$panelImg,
      panelText = _ref.panelText,
      panelColor = _ref.panelColor;

  var carouselStart = function carouselStart() {
    var images = panelImg;
    var i = 1;
    var img1 = document.querySelector("#img1");
    var img2 = document.querySelector("#img2");
    var divIndicadores = document.querySelector("#indicadores");

    for (var index = 0; index < images.length; index++) {
      var div = document.createElement("div");
      div.classList.add("circles");
      div.id = index;
      divIndicadores.appendChild(div);
    }

    img1.src = images[0];
    var circulos = document.querySelectorAll(".circles");
    circulos[0].classList.add("resaltado");

    var slideshow = function slideshow() {
      img2.src = images[i];
      var circulo_actual = Array.from(circulos).find(function (el) {
        return el.id === i;
      });
      Array.from(circulos).forEach(function (cir) {
        return cir.classList.remove("resaltado");
      });
      circulo_actual === null || circulo_actual === void 0 ? void 0 : circulo_actual.classList.add("resaltado");
      img1.classList.add("right");
      img2.classList.add("active");
      i++;

      if (i === images.length) {
        i = 0;
      }

      setTimeout(function () {
        img1.src = img2.src;
        img2.classList.remove("active");
        img1.classList.remove("right");
      }, 1000);
    };

    setInterval(slideshow, 4000);
  };

  (0, _react.useEffect)(function () {
    carouselStart();
  }, []);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    panelColor: panelColor,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      id: "slideshow",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        id: "img1"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
        id: "img2"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
      fontFamily: _variables.FontFamily.Raleway,
      color: _variables.GlobalColors.white,
      headerType: "product-name-header",
      text: panelText
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      id: "indicadores"
    })]
  });
};

exports.CarouselImagesLogin = CarouselImagesLogin;